import React from 'react';
import './WhyChooseUsAbout.css';
import { FaAward, FaHandshake, FaRegThumbsUp, FaChartLine } from "react-icons/fa";
export default function WhyChooseUsAbout() {
    const usps = [
        {
          icon: <FaAward className="usp-icon" />,
          title: "Industry Expertise",
          description: "Decades of experience in regulatory consulting and industrial liaison services.",
        },
        {
          icon: <FaHandshake className="usp-icon" />,
          title: "Strong Relationships",
          description:
            "Well-established connections with government authorities and regulatory bodies to streamline approvals.",
        },
        {
          icon: <FaRegThumbsUp className="usp-icon" />,
          title: "Proven Track Record",
          description:
            "A history of successfully assisting businesses with licensing, compliance, and certifications.",
        },
        {
          icon: <FaChartLine className="usp-icon" />,
          title: "Client Success",
          description:
            "Helping businesses achieve growth by ensuring smooth regulatory processes and timely clearances.",
        },
      ];
    
     
  return (
    <>
     <section className="why-choose-us-section">
      <div className="container">
        <h2 className="heading">Why Choose Us</h2>
        <p className="subheading">
          Discover what makes SARS India Liaison Pvt. Ltd. the trusted choice for regulatory and industrial consulting.
        </p>

        {/* USPs Section */}
        <div className="usps-grid">
          {usps.map((usp, index) => (
            <div key={index} className="usp-card">
              {usp.icon}
              <h3 className="usp-title">{usp.title}</h3>
              <p className="usp-description">{usp.description}</p>
            </div>
          ))}
        </div>

       
      </div>
    </section>
    
    
    
    
    
    
    </>
  )
}
